import { tickerTags } from "../../../mocks/fun";

export default function Ticker() {
  const doubled = [...tickerTags, ...tickerTags];
  return (
    <div className="relative z-10 -mt-1 border-y border-background-200 bg-primary-500">
      <div className="relative flex items-center overflow-hidden">
        <div className="absolute left-0 top-0 z-10 flex h-full items-center gap-1.5 rounded-r-xl bg-primary-600 px-3 py-1 text-background-50 md:px-4">
          <i className="ri-fire-fill"></i>
          <span className="hidden whitespace-nowrap text-sm font-semibold sm:inline">今日热梗</span>
        </div>
        <div className="flex w-full overflow-hidden">
          <div className="flex shrink-0 animate-ticker items-center gap-6 pl-40 md:pl-52">
            {doubled.map((tag, i) => (
              <span
                key={i}
                className="whitespace-nowrap py-3 text-sm font-medium text-background-50/90 md:text-[15px]"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}